(() => {
  // app/scripts/copy-link.js
  document.querySelectorAll(".copy-link").forEach((copyLink) => {
    copyLink.addEventListener("click", (e) => {
      e.preventDefault();
      let url = copyLink.getAttribute("href");
      let tooltip = copyLink.querySelector(".share-title");
      navigator.clipboard.writeText(url);
      tooltip.innerHTML = "Copied!";
      setTimeout(() => tooltip.innerHTML = "Copy link", 2e3);
    });
  });
})();
